const searchElem = document.querySelector('#title-search');
if (searchElem) {
    searchElem.addEventListener('keyup', fetchTitles);
}

/**
 * Fetch the requested section for the current chapter (defaults to section 1).
 * if current title list is not in front-end storage, store it.
 * if search is closed and a book was not selected, we redisplay the entire title list
 */
function fetchTitles() {
    let searchValue = event.target.value;

    let fetchUrl = 'fetch/inventory.php';
    let params = `s=${searchValue}`;
    let url = `${fetchUrl}?${params}`;

    fetch(url, {
        method: 'GET'
    })
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
            let isAuthenticated = data['isAuthenticated'];
            if(!isAuthenticated) {
                // Update title count in header
                let free_title_count = data['titles'].filter(title => title.free).length;
                let oldFreeHeader = document.querySelector('th#free-icon');

                oldFreeHeader.textContent = `Free (${free_title_count})`;
            }
            let title_count = data['titles'].length;
            let oldTitleHeader = document.querySelector('th#book-title');

            let table, oldTableBody;

            oldTitleHeader.textContent = `Title (${title_count})`;

            let tbody = document.createElement('tbody');

            if (data['titles'].length > 0) {
                // update titles
                data['titles'].forEach((item) => {
                    if (['CWWL', 'CWWN'].includes(data['pub_type'])) {
                        tbody = collectionsTableRowsFor(item, tbody);
                    } else {
                        tbody = generalTableRowsFor(item, tbody, isAuthenticated);
                    }
                })

                oldTableBody = document.querySelector('table#inventory tbody');
                table = oldTableBody.parentElement;
                table.replaceChild(tbody, oldTableBody);
            }

            document.body.style.cursor = 'default';
        })
        .catch((error) => {
            console.log('request failed', error)
            document.body.style.cursor = 'default';
        });
}

// fetch API helper methods
function checkStatus(response) {
    if (response.status >= 200 && response.status < 300) {
        return response;
    } else {
        let error = Error(response.statusText)
        error.response = response;
        throw error
    }
}

function parseJSON(response) {
    return response.json();
}

/**
 * Generates the book table row for a 'Collected Works' volume for one of the Collected Works pages - CWWL / CWWN
 * @param item
 * @param tbody
 * @returns {*}
 */
function collectionsTableRowsFor(item, tbody) {
    let tr, td1, td2;
    let a, url;

    tr = document.createElement('tr');

    // td 1 or 2
    td1 = document.createElement('td');
    td1.setAttribute('headers', 'year-vol');
    td1.innerText = `${decode(item['year'])} (${decode(item['volume_number'])})`;
    tr.appendChild(td1);

    // td 2 of 2
    td2 = document.createElement('td');
    td2.setAttribute('headers', 'book-title');
    url = `reader.php?id=${item['id']}`;
    a = document.createElement('a');
    a.setAttribute('href', url);
    a.innerText = decode(item['section_name']);
    td2.appendChild(a);
    tr.appendChild(td2);

    tbody.appendChild(tr);

    return tbody;
}

/**
 * Generates the book table row for the book titles pages that are not collection specific (e.g., A-Z book list).
 * @param item
 * @param tbody
 * @param isAuthenticated
 * @returns {*}
 */
function generalTableRowsFor(item, tbody, isAuthenticated) {
    let tr, td;
    let div, div2, i, a, url;
    let key, content;

    tr = document.createElement('tr');

    // td - Free title
    if(!isAuthenticated) {
        td = document.createElement('td');
        if(item['free']) {
            key = '1';
            content = "<span class='label'>free</span>";
        } else {
            key = '0';
            content = '';

        }

        td.setAttribute('headers', 'free-icon');
        td.setAttribute('sorttable_customkey', key);

        div = document.createElement('div');
        div.classList.add('on');
        div.innerHTML = content;
        td.appendChild(div);
        tr.appendChild(td);
    }

    // td - Book Title
    td = document.createElement('td');
    td.setAttribute('headers', 'book-title');
    url = `reader.php?id=${item['id']}`;
    if(isAuthenticated || item['free']) {
        a = document.createElement('a');
        a.setAttribute('href', url);
        a.innerText = decode(item['section_name']);
        td.appendChild(a); } else {
        td.innerText = decode(item['section_name']);
    }
    tr.appendChild(td);

    // td - Year, volume
    td = document.createElement('td');
    td.innerText = '--';
    if(!item['ls']) {
        td.setAttribute('headers', 'volume');
        td.innerText = `${item['year']},  Vol. ${item['volume_number']}`;
    }
    tr.appendChild(td);

    // td - Category
    td = document.createElement('td');
    td.setAttribute('headers', 'category');
    td.innerText = item['category'] ?? '\u00A0'; // &nbsp;
    tr.appendChild(td);

    // td - Author
    td = document.createElement('td');
    td.setAttribute('headers', 'author');
    td.innerText = item['author'] ?? '\u00A0'; // &nbsp;
    tr.appendChild(td);

    if(isAuthenticated) {
        // td - Completed
        td = document.createElement('td');
        td.setAttribute('headers', 'completed-icon');

        div = document.createElement('div');
        div.classList.add('on');
        if (item['dateCompleted']) {
            i = document.createElement('i');
            i.classList.add('fas', 'fa-check-circle', 'fa-lg');
            div.appendChild(i);
        }
        td.appendChild(div);

        div2 = document.createElement('div');
        div2.classList.add('date');
        div2.innerText = item['dateCompleted'] ?? '\u00A0'; // &hbsp;
        td.appendChild(div2);
        tr.appendChild(td);
    }

    tbody.appendChild(tr);

    return tbody;
}

const HtmlEntities = function () {
};

/**
 * Convert all special characters in a string
 * @param {*} string text string to be converted
 */
HtmlEntities.map = {
    " ": "&nbsp;",
    "—": "&mdash;",
    "–": "&ndash;",
    "&": "&amp;",
    '"': "&quot;",
    "‘": "&lsquo;",
    "’": "&rsquo;",
    "“": "&ldquo;",
    "”": "&rdquo;",
    "…": "&hellip;",
    "é": "&eacute;",
};

/**
 * Convert all special characters in a string
 * @param {*} string text string to be converted
 */
function decode(string) {
    if (string) {
        let entityMap = HtmlEntities.map;
        for (let key in entityMap) {
            let entity = entityMap[key];
            let regex = new RegExp(entity, "g");
            string = string.replace(regex, key);
        }
        string = string.replace("--", "—");
        return string;
    }
    return "";
}
